import { useMemo, useState } from "react";
import { galleryCategories, galleryItems } from "@/mocks/gossipData";

export default function Gallery() {
  const [cate, setCate] = useState("全部");

  const list = useMemo(
    () =>
      cate === "全部"
        ? galleryItems
        : galleryItems.filter((it) => it.cate === cate),
    [cate]
  );

  return (
    <section id="topic" className="mx-auto max-w-[1360px] scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-sign-600">
            Deep Dive Archive
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black text-ink-950 md:text-3xl">
            深扒专题精选
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-7 text-ink-500">
            每一篇都是把镜头拉到最近、把时间轴拉到最平的完整拆解。点选分类，看看哪路工法最对你胃口。
          </p>
        </div>
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {galleryCategories.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => setCate(c)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
              cate === c
                ? "bg-ink-900 text-paper-50"
                : "border border-ink-800/15 text-ink-600 hover:border-sign-400 hover:text-sign-700"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="mt-7 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((it) => (
          <article
            key={it.id}
            className="group flex flex-col overflow-hidden rounded-xl border border-ink-800/10 bg-paper-50 transition-colors hover:border-sign-300"
          >
            <div className="relative overflow-hidden">
              <img
                src={it.img}
                alt={`${it.title} · 真瓜研究所深度拆解`}
                loading="lazy"
                className="h-48 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute left-3 top-3 flex items-center gap-2">
                <span className="rounded-md bg-paper-50/90 px-2 py-1 text-[11px] font-bold text-ink-800 backdrop-blur">
                  {it.cate}
                </span>
                <span
                  className={`rounded-md px-2 py-1 text-[11px] font-bold backdrop-blur ${
                    it.lv === "高阶"
                      ? "bg-sign-500 text-paper-50"
                      : it.lv === "进阶"
                        ? "bg-sun-500 text-ink-950"
                        : "bg-melon-500 text-paper-50"
                  }`}
                >
                  {it.lv}
                </span>
              </div>
            </div>

            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-heading text-base font-bold leading-7 text-ink-900 transition-colors group-hover:text-sign-700 md:text-[17px]">
                {it.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-6 text-ink-500">{it.excerpt}</p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {it.tags.map((t) => (
                  <span key={t} className="rounded-full border border-ink-800/10 px-2 py-0.5 text-[11px] text-ink-500">
                    #{t}
                  </span>
                ))}
              </div>
              <div className="mt-4 flex items-center gap-4 border-t border-ink-800/10 pt-3 text-xs text-ink-400">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" /> {it.reads}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" /> {it.hours}
                </span>
                <span className="ml-auto">{it.date}</span>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <button
          type="button"
          onClick={() => document.getElementById("class")?.scrollIntoView({ behavior: "smooth" })}
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-ink-800/20 px-6 py-3 text-sm font-semibold text-ink-700 transition-colors hover:border-sign-400 hover:text-sign-700"
        >
          还没入门？先去显微镜课堂打基础
          <i className="ri-arrow-down-line" />
        </button>
      </div>
    </section>
  );
}